// Fallback utilisé si process.env.CLIENT n'est pas défini (ex: `npm run dev` sans préciser de client).
export default {
  appTitle: 'Web Mobile',
  imagesProxyUrl: 'https://imagesproxy.mimatech.ch'
}
